const TYPE = {
    INT: 1001,
    FLOAT: 1002,
    CHAR: 1003,
    BOOL: 1004,
    STRING: 1005,
    VOID: 1006,
    POINTER: 1007,
    ERROR: 1008
}

function GeneralType (type) {
    this.type = type
    this.array = false
    this.size = 1
    this.reference = false
    this.external = false
    this.codeReference = false
    this.parameter = false
}

GeneralType.prototype = {
    isInt () {
        return this.type === TYPE.INT
    },
    isFloat () {
        return this.type === TYPE.FLOAT
    },
    isChar () {
        return this.type === TYPE.CHAR
    },
    isBool () {
        return this.type === TYPE.BOOL
    },
    isString () {
        return this.type === TYPE.STRING
    },
    isVoid () {
        return this.type === TYPE.VOID
    },
    isError () {
        return this.type === TYPE.ERROR
    },
    isNumeric () {
        return this.type === TYPE.INT || this.type === TYPE.FLOAT
    },
    isRelational () {
        return this.type === TYPE.INT || this.type === TYPE.FLOAT || this.type === TYPE.CHAR
    },
    isArray () {
        return this.array
    },
    isExternal () {
        return this.external
    },
    isValidIndex (index) {
        return index >= 0 && index < this.size
    },
    isReference () {
        return this.reference
    },
    isCodeReference () {
        return this.codeReference
    },
    isParameter () {
        return this.parameter
    },
    setError () {
        this.type = TYPE.ERROR
        this.array = false
    },
    setAsArray () {
        this.array = true
    },
    setAsExternal () {
        this.external = true
    },
    setAsReference () {
        this.reference = true
    },
    setSize (size) {
        this.size = size
    },
    setAsCodeReference () {
        this.codeReference = true
    },
    setAsParameter () {
        this.parameter = true
    },
    getSize (size) {
        return this.size
    },
    getTypeCode () {
        return this.type
    },
    eq (type) {
        return this.type === type.getTypeCode()
    },
    toString () {
        let str = ''
        if (this.type === TYPE.INT) {
            str = 'int'
        } else if (this.type === TYPE.FLOAT) {
            str = 'float'
        } else if (this.type === TYPE.CHAR) {
            str = 'char'
        } else if (this.type === TYPE.ERROR) {
            str = 'error'
        } else if (this.type === TYPE.VOID) {
            str = 'void'
        } else if (this.type === TYPE.STRING) {
            str = 'str'
        } else if (this.type === TYPE.BOOL) {
            str = 'bool'
        } else if (this.type === TYPE.POINTER) {
            str = 'ptr'
        }
        if (this.array) {
            str = 'array(' + str + ')'
        }
        if (this.reference) {
            str = '&' + str
        }
        if (this.codeReference) {
            str = 'cod ' + str
        }
        if (this.parameter) {
            str = 'par ' + str
        }
        if (this.external) {
            str = 'e-' + str
        }
        return str
    },
    clone () {
        let copy = new GeneralType(this.type)
        copy.array = this.array
        copy.size = this.size
        copy.reference = this.reference
        copy.external = this.external
        copy.codeReference = this.codeReference
        copy.parameter = this.parameter
        return copy
    }
}

function TypeInt () {
    return new GeneralType(TYPE.INT)
}

function TypeFloat () {
    return new GeneralType(TYPE.FLOAT)
}

function TypeChar () {
    return new GeneralType(TYPE.CHAR)
}

function TypeBool () {
    return new GeneralType(TYPE.BOOL)
}

function TypeString () {
    return new GeneralType(TYPE.STRING)
}

function TypeVoid () {
    return new GeneralType(TYPE.VOID)
}

function TypePointer () {
    return new GeneralType(TYPE.POINTER)
}

function TypeError () {
    return new GeneralType(TYPE.ERROR)
}

export {TypeInt, TypeFloat, TypeChar, TypeBool, TypeString, TypeError, TypePointer, TypeVoid}



// WEBPACK FOOTER //
// ./src/Core/Parser/TypeDefinition.js